import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu } from "antd";
import { isAuthenticated, logoutAndRedirect } from "../../../commons/Auth/auth";
import { useTranslation } from "react-i18next";
import "./NormalUserSidebar.css";

const Icon = ({ children }) => (
  <svg
    className="nu-sidebar__icon"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    focusable="false"
  >
    {children}
  </svg>
);

const CalendarIcon = () => (
  <Icon>
    <rect x="3" y="4" width="18" height="18" rx="2" />
    <line x1="16" y1="2" x2="16" y2="6" />
    <line x1="8" y1="2" x2="8" y2="6" />
    <line x1="3" y1="10" x2="21" y2="10" />
  </Icon>
);

const NAV = [
  {
    key: "/client/dashboard",
    label: "Dashboard",
    icon: (
      <Icon>
        <rect x="3" y="3" width="7" height="7" />
        <rect x="14" y="3" width="7" height="7" />
        <rect x="3" y="14" width="7" height="7" />
        <rect x="14" y="14" width="7" height="7" />
      </Icon>
    )
  },
  {
    key: "/client/offers",
    label: "Offers",
    icon: (
      <Icon>
        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
        <polyline points="14 2 14 8 20 8" />
        <polyline points="9 15 11 17 15 13" />
      </Icon>
    )
  },
  {
    key: "/client/invoices",
    label: "Invoices",
    icon: (
      <Icon>
        <rect x="2" y="5" width="20" height="14" rx="2" />
        <line x1="2" y1="10" x2="22" y2="10" />
      </Icon>
    )
  },
  { key: "/client/appointments", label: "Appointments", icon: <CalendarIcon /> },
  {
    key: "/client/documents",
    label: "Documents",
    icon: (
      <Icon>
        <path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z" />
      </Icon>
    )
  },
  {
    key: "/client/messages",
    label: "Messages",
    icon: (
      <Icon>
        <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
      </Icon>
    )
  },
  { key: "/client/projects", label: "Projects", icon: <CalendarIcon /> },
  {
    key: "/client/my-profile",
    label: "My Profile",
    icon: (
      <Icon>
        <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
        <circle cx="12" cy="7" r="4" />
      </Icon>
    )
  }
];

const handleLogout = () => logoutAndRedirect();

/** End-customer navigation. Renders inside the shell's desktop Sider and the phone nav Drawer. */
const NormalUserSidebar = () => {
  const { t } = useTranslation("dashboard");
  const { pathname } = useLocation();
  const user = isAuthenticated();

  const getInitials = () => {
    const first = user?.firstName?.[0] || "";
    const last = user?.lastName?.[0] || "";
    return (first + last).toUpperCase() || "U";
  };

  // "/client" is the dashboard too.
  const selected =
    pathname === "/client" ? "/client/dashboard" : NAV.find(i => pathname.includes(i.key))?.key;

  const items = NAV.map(item => ({
    key: item.key,
    icon: item.icon,
    label: <Link to={item.key}>{t(item.label)}</Link>
  }));

  return (
    <div className="nu-sidebar">
      <div className="nu-sidebar__profile">
        <div className="nu-sidebar__avatar">
          {user?.picture?.url ? (
            <img src={user.picture.url} alt="" />
          ) : (
            <span>{getInitials()}</span>
          )}
        </div>
        <div className="nu-sidebar__user">
          <div className="nu-sidebar__name">
            {user?.firstName} {user?.lastName}
          </div>
          <div className="nu-sidebar__role">{user?.description || t("Member")}</div>
        </div>
      </div>

      <Menu
        className="sidersidenav nu-sidebar__menu"
        mode="inline"
        theme="light"
        selectedKeys={selected ? [selected] : []}
        items={items}
      />

      <Menu
        className="nu-sidebar__logout"
        mode="inline"
        theme="light"
        selectable={false}
        onClick={handleLogout}
        items={[
          {
            key: "logout",
            danger: true,
            icon: (
              <Icon>
                <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
                <polyline points="16 17 21 12 16 7" />
                <line x1="21" y1="12" x2="9" y2="12" />
              </Icon>
            ),
            label: t("Logout")
          }
        ]}
      />
    </div>
  );
};

export default NormalUserSidebar;
